// extracted by mini-css-extract-plugin
export default {"text-card-section":"TextCard_text-card-section__wcbb1","text-card":"TextCard_text-card__kRXCR"};